<template>
  <div class="columns is-multiline c-onboarding-theme">
    <div
      class="column is-4 c-onboarding-theme--item"
      v-for="(item, index) in content"
      :key="index"
    >
      <p>{{ item.name }}</p>
      <img :src="item.img" :alt="item.name" />
      <div class="c-onboarding-theme__variation-colors">
        <p v-if="item.withColorsVariation">
          <img :src="variationColorsIcon" alt="Variação de cores" /> Diversas
          opções de cores
        </p>
      </div>
      <button class="button is-primary" @click="choiceTheme(item)">
        Usar este modelo
      </button>
    </div>
  </div>
</template>

<script>
import variationColorsIcon from '@/assets/img/onboarding-create-site/color-variation-icon.svg'

export default {
  data() {
    return {
      answerSteps: {},
      variationColorsIcon,
    }
  },

  props: {
    stepNumber: Number,
    content: Array,
  },

  computed: {
    answerUser: {
      get() {
        return this.$store.state.onboardingCreateSite.answersOfStep
      },
      set(payload) {
        this.$store.dispatch('setAnswer', payload)
      },
    },
  },

  mounted() {
    if (localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)) {
      this.answerSteps = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )
    }
  },

  methods: {
    getStepNumber() {
      const stepNumber = this.$route.params.id.split('-')
      return parseInt(stepNumber[1])
    },

    choiceTheme(value) {
      this.nextStep = true
      this.answerUser.step9 = value.theme_id

      //get data of localstorage
      this.answerSteps = JSON.parse(
        localStorage.getItem(`onboarding_wed${this.answerUser.wed_id}`)
      )

      !this.answerSteps
        ? (this.answerSteps = { website_theme: value.theme_id })
        : (this.answerSteps.website_theme = value.theme_id)

      //set update data in localstorage
      localStorage.setItem(
        `onboarding_wed${this.answerUser.wed_id}`,
        JSON.stringify(this.answerSteps)
      )

      this.$router.push({ path: '/onboarding/passo-10' })
    },
  },
}
</script>

<style lang="scss" scoped>
.c-onboarding-theme {
  padding: 30px 20px;
  &--item {
    position: relative;
    margin-bottom: 25px;

    p {
      margin-bottom: 10px;
    }
  }

  &__variation-colors {
    height: 27px;

    > p {
      display: flex;
      justify-content: center;
      font-size: 12px;
      font-weight: bold;
      color: $gray-7;
      > img {
        margin-right: 8px;
      }
    }
  }
}
</style>
